import React from 'react'
import "./Investments.css";
import ark from "../../assets/icons/investmentsIcons/arkIcon.svg";
import rehla from "../../assets/icons/investmentsIcons/rehlaIcon.svg";
import saudiElan  from "../../assets/icons/investmentsIcons/saudiElanIcon.svg";
import uvera  from "../../assets/icons/investmentsIcons/uveraIcon.svg";
import regard from  "../../assets/icons/investmentsIcons/regardaIcon.svg";
import lead from  "../../assets/icons/investmentsIcons/leadIcon.svg";
import velents from  "../../assets/icons/investmentsIcons/velentsIcon.svg";
import edama from  "../../assets/icons/investmentsIcons/edamaIcon.svg";
import nama from  "../../assets/icons/investmentsIcons/namaIcon.svg";
import wijha from  "../../assets/icons/investmentsIcons/wijhaIcon.svg";
import gbo from  "../../assets/icons/investmentsIcons/gboIcon.svg";
import darcaif from  "../../assets/icons/investmentsIcons/darcaifIcon.svg";
import moneymoon from "../../assets/icons/investmentsIcons/moneymoon.png";
import krti from "../../assets/icons/investmentsIcons/KRTI.png";
import whitefooter from "../../assets/whitefooter.svg";
import hakbah from "../../assets/icons/hakbah.png";
import point2 from "../../assets/whitepoint.svg";
import lawazem from "../../assets/icons/investmentsIcons/lawazem.svg"

import waheedbg from "../../assets/icons/bg.svg";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

export default function Investments() {
    const { t, i18n } = useTranslation();

  return (
    <section id="investments">
      <div
        style={{
          height: "auto",
          background: "#022539",
          paddingBottom: "30px",
        }}
      >
        <div className="title-container">
          <img src={point2} className="bulletPoint" />
          <h1 className="my-investments">{t("my_investments")}</h1>
          <img src={point2} className="bulletPoint" />
        </div>

        {/* <p className="p-content">{t("investment_p")}</p> */}
        <div className="investment-container">
          <img src={waheedbg} alt="bg" className="waheed-bg" />

          <div className="investments-icons">
            {/* <a
              href="https://arktec.sa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ark} />
            </a> */}
            <a
              href="https://rehlacar.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={rehla} />
            </a>
            <a
              href="https://www.uvera.co/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={uvera} />
            </a>
            <a
              href="https://saudielan.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={saudiElan} />
            </a>
            <a
              href="https://www.regards.sa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={regard} />
            </a>
            <img src={lead} />
            {/* <img src={regard} style={{ marginTop: "-60px" }} />
            <img src={lead} style={{ marginTop: "-20px" }} /> */}
            <a
              href="https://velents.ai/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={velents} />
            </a>
            <a
              href=" http://www.edama.com.sa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={edama} />
            </a>
            <a
              href="https://namare.sa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={nama} />
            </a>
            {/* <a href="#" target="_blank" rel="noopener noreferrer">
              <img src={wijha} />
            </a> */}
            <a href="https://gbo.sa/" target="_blank" rel="noopener noreferrer">
              <img src={gbo} />
            </a>

            <a
              href="https://www.instagram.com/dar_caif/?hl=ar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={darcaif} />
            </a>
            <a
              href="https://moneymoon.sa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={moneymoon} />
            </a>

            <a
              href="https://hakbah.sa/"
              target="_blank"
              rel="noopener noreferrer"
              // className="single-item"
            >
              <img className="single-item" src={hakbah} />
            </a>
            <a
              href="https://www.lawazem.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="single-item"
            >
              <img className="middle-item" src={lawazem} />
            </a>
          </div>

          <img src={whitefooter} alt="white-footer" className="white-footer" />
        </div>
        {/* <img src={waheed} alt='waheed-logo' className='waheed-logo'/> */}
      </div>
    </section>
  );
}
